export enum TaxReportType {
    IOSS = 1,
    OSS,
    Regular,
    UK,
    Purchases,
    Sales,
}
